import { render, staticRenderFns } from "./YourResponibilityCheckListTab.vue?vue&type=template&id=2d1228b4&scoped=true"
import script from "./YourResponibilityCheckListTab.vue?vue&type=script&setup=true&lang=js"
export * from "./YourResponibilityCheckListTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./YourResponibilityCheckListTab.vue?vue&type=style&index=0&id=2d1228b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1228b4",
  null
  
)

export default component.exports